import { Chip, useTheme } from '@mui/material';
import { Iconify } from 'src/components/iconify';
import { useLocales } from 'src/locales';

export const ForwardChip = () => {
  const theme = useTheme();
  const { translate } = useLocales();
  return (
    <Chip
      label={translate('shared.labels.forwarded')}
      variant="soft"
      size="small"
      color="success"
      icon={<Iconify icon="tabler:arrow-forward-up" />}
      style={{
        padding: '4px 4px',
        borderRadius: '8px',
        backgroundColor: 'rgba(145, 158, 171, 0.08)',
        fontStyle: 'italic',
        color: theme.palette.grey[600],
        fontFamily: theme.typography.fontFamily,
      }}
      sx={{ pointerEvents: 'none' }}
    />
  );
};
